import { render } from "./TariffsIndividualSparkKzItem.vue?vue&type=template&id=75cc71c2&scoped=true&ts=true"
import script from "./TariffsIndividualSparkKzItem.vue?vue&type=script&lang=ts"
export * from "./TariffsIndividualSparkKzItem.vue?vue&type=script&lang=ts"

import "./TariffsIndividualSparkKzItem.vue?vue&type=style&index=0&id=75cc71c2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cc71c2"]])

export default __exports__